import { useState } from "react";
import { useTablesContext } from "../../../../context/tablesContextProvider";
import { TableNames } from "../../../../enums/tableNames";

/**
 * Search term state management hook with context restoration
 *
 * Manages search text state with automatic restoration from table context.
 * Each tab maintains its own search history, so switching between tabs
 * preserves the search term for each individual tab.
 *
 * @param {string} tabId - Auth status tab identifier (e.g., "pending", "hold")
 * @returns {Object} Search term state
 * @returns {string} returns.searchTerm - Current search text
 * @returns {Function} returns.setSearchTerm - Setter for updating search term
 *
 * @example
 * const { searchTerm, setSearchTerm } = useSearchTerm("pending");
 * setSearchTerm("patient name");
 */
export const useSearchTerm = (tabId: string) => {
  const { getTableDataFromContext } = useTablesContext();
  const tableAttributes = getTableDataFromContext(
    `${TableNames.GENERIC_AUTH_STATUS_ORDERS}_${tabId}`,
  );

  const [searchTerm, setSearchTerm] = useState(
    tableAttributes?.searchedText ?? "",
  );

  return {
    searchTerm,
    setSearchTerm,
  };
};
